import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ShameClinicSection } from './components/ShameClinicSection';
import { TransformationSection } from './components/TransformationSection';
import { CharactersGrid } from './components/CharactersGrid';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { DirectOfferSection } from './components/DirectOfferSection';
import { AuthorSection } from './components/AuthorSection';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-crema font-sans text-body selection:bg-gold/30" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ShameClinicSection data-id="element-4" />
        <TransformationSection data-id="element-5" />
        <CharactersGrid data-id="element-6" />
        <WhatYouGetSection data-id="element-7" />
        <ObjectionsSection data-id="element-8" />
        <DirectOfferSection data-id="element-9" />
        <AuthorSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}